import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'appDate',
    standalone: false
})
export class AppDatePipe implements PipeTransform {

  constructor(private datepipe: DatePipe) { }

  transform(value: string | number | Date, args?: any): string {
     return this.datepipe.transform(value, 'd-MMM-YYYY');
  }

}
